import React from "react";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";

export default function StepperComponent({
  titles,
  steps
}: {
  titles: string[];
  steps: any[];
}) {
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  return (
    <div>
      <Stepper activeStep={activeStep} orientation="vertical">
        {titles.map((title: string, index: number) => (
          <Step key={title}>
            <StepLabel
              style={{ cursor: "pointer" }}
              onClick={() => setActiveStep(index)}
            >
              {title}
            </StepLabel>
            <StepContent>
              <div>{steps[index]}</div>
              {activeStep < steps.length - 1 && (
                <div className="mb-2">
                  <div>
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="mt-1 mr-1"
                    >
                      Back
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      className="mt-1 mr-1"
                    >
                      Next
                    </Button>
                  </div>
                </div>
              )}
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}
